export default "__VITE_ASSET__UDD4Xs37__"